import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { base_url } from '../../../api/api-url';
import { getAuthHeaders } from '../../../utility/getAuthHeaders';


export const fetchCategories = createAsyncThunk('category/fetchAll', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${base_url}/category`, getAuthHeaders());
    return response.data.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});


export const createCategory = createAsyncThunk('category/create', async (payload, thunkAPI) => {
  try {
    await axios.post(`${base_url}/category`, payload, getAuthHeaders());
    thunkAPI.dispatch(fetchCategories()); // refresh after create
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});


export const updateCategory = createAsyncThunk('category/update', async ({ id, data }, thunkAPI) => {
  try {
    await axios.put(`${base_url}/category/${id}`, data, getAuthHeaders());
    thunkAPI.dispatch(fetchCategories()); // refresh after update
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const deleteCategory = createAsyncThunk('category/delete', async (id, thunkAPI) => {
  try {
    await axios.delete(`${base_url}/category/${id}`, getAuthHeaders());
    thunkAPI.dispatch(fetchCategories()); // refresh after delete
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});

const categorySlice = createSlice({
  name: 'category',
  initialState: {
    categories: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearCategoryError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCategory.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(deleteCategory.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearCategoryError } = categorySlice.actions;
export default categorySlice.reducer;
